import React, { Fragment} from "react";
import { useLocation } from "react-router";

import { getActiveTabFooter } from "./helpers";
import PageHeading from "Layout/AppMain/PageHeading";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { ControlshermProvider } from "./Controlscherm/context/ControlshermContext";
import { useGebruikerContext } from "../Context/GebruikerContext";
import { getActiveTab, getTabsMenus } from "../Common/helpers";

const PlanscreenGebruiker = () => {
	const location = useLocation();
	const { activeTab, setActiveTab, isActiveTab, userTabs, tabsLoader } = useGebruikerContext();
	const tabsList = getTabsMenus(userTabs)

	const filteredTabsList = tabsList.filter(item => !["Personalia", "Besturen", "Historie", "Min/Max"].includes(item.name));

	return (
		<Fragment>
			
					<ControlshermProvider>
					
							<div className="app-main__inner gebruikers-view planscreen-gebruikers__view p-0">
								<PageHeading
									useDefaultPath={false}
									additionalBreadcrumbs={[
										{
											href: "/#" + location.pathname,
											label: tabsList.find((t) => t.key === activeTab)?.name,
										},
									]}
								/>
								<TransitionOnLoad>
									<Fragment>
										<div
											className="d-flex gap-4"
											style={{
												marginBottom: `${
													activeTab === userTabs.Urenoverzicht ||
													activeTab === userTabs.Beschikbaarheid
														? "50px"
														: "20px"
												}`,
											}}
										>
											<div
												className={
													activeTab === userTabs.Beschikbaarheid
														? "w-auto user-ctn col"
														: " user-ctn w-auto col"
												}
											>
												{getActiveTab(userTabs, activeTab)}
											</div>

											{activeTab !== userTabs.Beschikbaarheid && (
												<div className="users-tab planscreen-gebruikers__tabs">
													{!tabsLoader && filteredTabsList.map((item) => {
														return (
															<p
																key={item.key}
																className={
																	isActiveTab(item.key)
																		? "active"
																		: ""
																}
																onClick={() => {
																	setActiveTab(item.key);
																}}
															>
																{item.icon} {item.name}
															</p>
														);
													})}
												</div>
											)}
										</div>
									</Fragment>
								</TransitionOnLoad>
							</div>

							{getActiveTabFooter(userTabs, activeTab)}
						
					</ControlshermProvider>

		</Fragment>
	);
};

export default PlanscreenGebruiker;
